module.exports = __webpack_public_path__ + "media/img/list-arrow-260666bc18053f41505a524c406edd61.svg";